import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import useStore from './../store.js';
import { CRI_COLORS, ECON_COLORS, EDU_COLORS, FAM_COLORS, HEAL_COLORS, COMM_COLORS, DISABLED_COLORS } from './../../../../constants/colors';
import { getQuintileDesc } from './../utils';

var InteractiveScale = function InteractiveScale(_ref) {
  var props = _extends({}, _ref);

  var isLoaded = useRef(false); // Generic state setter.

  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  }); // Active metric

  var activeMetric = useStore(function (state) {
    return state.activeMetric;
  }); // const setActiveMetric = useStore(
  //   state => state.setActiveMetric,
  // )
  // Active quintiles

  var activeQuintiles = useStore(function (state) {
    return state.activeQuintiles;
  }); // const setActiveQuintiles = useStore(
  //   state => state.setActiveQuintiles,
  // )

  var getBgColor = function getBgColor(metric, quintile) {
    // console.log('getBgColor')
    return metric.colors[quintile];
  };

  var getQuintileAriaLabel = function getQuintileAriaLabel(quintile) {
    var quintileDesc = i18n.translate(getQuintileDesc(quintile));

    if (props.metric.id === activeMetric && activeQuintiles[quintile] == 1) {
      return i18n.translate('UI_MAP_PANEL_QUINTILE_DISABLE', {
        quintile: quintileDesc
      });
    } else {
      return i18n.translate('UI_MAP_PANEL_QUINTILE_ENABLE', {
        quintile: quintileDesc
      });
    }
  };

  var handleScaleClick = function handleScaleClick(e) {
    e.preventDefault(); // console.log('handleScaleClick(), ', e.currentTarget)
    // If already active, just return

    if (e.currentTarget.classList.contains('active')) {
      return;
    } else {
      // setActiveMetric
      var metric = String(e.currentTarget.id).replace('metric_select_', '');
      setStoreValues({
        activeMetric: metric,
        activeQuintiles: [1, 1, 1, 1, 1]
      }); // setActiveMetric(metric)
      // setActiveQuintiles([1, 1, 1, 1, 1])
    }
  };

  var getElIndex = function getElIndex(element) {
    return Array.from(element.parentNode.children).indexOf(element);
  };

  var handleQuintileClick = function handleQuintileClick(e) {
    e.preventDefault(); // console.log('handleQuintileClick(), ', e.currentTarget)
    // If parent not active, just return

    if (!e.currentTarget.parentNode.classList.contains('active')) {
      return;
    }

    var quintile = getElIndex(e.currentTarget);
    var quintiles = activeQuintiles.slice(); // If set was all enabled, knock other selections.

    if (quintiles[0] === 1 && quintiles[1] === 1 && quintiles[2] === 1 && quintiles[3] === 1 && quintiles[4] === 1) {
      quintiles = [0, 0, 0, 0, 0];
      quintiles[quintile] = 1;
    } else {
      quintiles[quintile] = Number(quintiles[quintile]) === 1 ? 0 : 1;
    } // setActiveQuintiles(quintiles)


    setStoreValues({
      activeQuintiles: quintiles
    });
  };

  var getScaleAriaLabel = function getScaleAriaLabel() {
    // console.log('getScaleAriaLabel()')
    var metricTitle = i18n.translate(props.metric.title);
    var prompt = activeMetric === props.metric.id ? 'UI_MAP_PANEL_METRIC_DISABLE' : 'UI_MAP_PANEL_METRIC_ENABLE';
    var label = i18n.translate(prompt, {
      metric: metricTitle
    }); // console.log('label, ', label)

    return label;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: clsx('interactive-scale', 'button-metric', activeMetric === props.metric.id ? 'active' : '', 'button-' + props.metric.id),
    id: 'metric_select_' + props.metric.id,
    onClick: handleScaleClick,
    "aria-label": getScaleAriaLabel()
  }, activeQuintiles.map(function (val, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx('quintile-button', props.metric.id === activeMetric && Number(val) === 1 ? 'active' : '', 'quintile-' + i),
      style: {
        backgroundColor: props.metric.id === activeMetric && Number(val) === 1 ? getBgColor(props.metric, i) : DISABLED_COLORS[i]
      },
      onClick: handleQuintileClick,
      key: 'quintile_button_' + i,
      "aria-label": getQuintileAriaLabel(i)
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, getQuintileAriaLabel(i)));
  }));
};

InteractiveScale.defaultProps = {
  metric: {}
};
export default InteractiveScale;